module.exports = __webpack_public_path__ + "img/16_74.48b76820.png";